import React, {useCallback, useEffect, useState} from 'react';
import { useHistory } from "react-router-dom";
import {useAlert, useInput, useRequest} from "../../hooks";
import {emailRegExp} from "../../utils/utilityEtc";
import clsx from "clsx";
import {URL} from "../../constant";
import {revokeEmailAPI} from "../../api/entryExternal";
import {diagnosisResultAPI} from "../../api/diagnosisAPI";

function GoogleLeavePage(props) {
  const { push } = useHistory();
  const [pwShow, setPwShow] = useState(false);
  const [agree, setAgree] = useState(false);
  const [input, setInput] = useState(false);
  const [email, onChangeEmail] = useInput('');
  const [pwd, onChangePwd] = useInput('');
  const [messageAlert] = useAlert();

  const [revokeEmailAPICall, result] = useRequest((data) =>
    revokeEmailAPI(data)
  );

  useEffect(() => {
    const result = emailRegExp(email);
    if (email && pwd && result) {
      setInput(true);
    } else {
      setInput(false);
    }
  }, [pwd, email]);

  useEffect(() => {
    if (!result) return;
    push(URL.LEAVE.SUCCESS);
  }, [result]);

  const handleAgree = useCallback(() => {
    setAgree(!agree);
  }, [agree]);

  const handlePwShow = useCallback(() => {
    setPwShow(!pwShow)
  }, [pwShow])

  const onSubmit = () => {
    try {
      if (!input || !agree) return;
      revokeEmailAPICall({ emailAdrs: email, pw: pwd });


    } catch (error) {
      console.log("##### onSubmit error: ", error);
    }
  }

  return (
    <div className="sub_page app_withdrawal mb_paused">
      <main className="container acc_main">
        <audio preload="auto" className="audio_wrap">
          <source className="audio_source"/>
        </audio>
        <section className="main_contents">
          <div className="wrap">
            <h3 className="logo_head">
              <figure className="logo">
                <img src={`${process.env.PUBLIC_URL}/static/images/icon/logo_ai_barosem.webp`} alt=""/>
              </figure>
            </h3>
            <article className="mb_paused_desc">
              <p className="desc_txt">탈퇴 시 아래 유의사항을 꼭 확인해 주세요.</p>
            </article>
            <article className="acc_form form_wrap">
              <form className="acc_form_wrap">
                <div className="acc_form_inner">
                  <div className="withdrawal_verifi">
                    <div className="withdrawal_verifi_desc type2">
                      <div className="inner newscroll_bar_grey">
                        <ul>
                          <li>
                            <p>
                              <span className="num">1.</span>
                              탈퇴 후 재가입이 가능합니다.
                            </p>
                          </li>
                          <li>
                            <p>
                              <span className="num">2.</span>
                              회원 탈퇴와 함께 고객님의 개인 정보 및 학습 데이터는 모두 삭제되며, 재가입 후 복구할 수 없습니다
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="withdrawal_verifi_agree">
                      <div className="check_box_wrap">
                        <input
                          type="checkbox"
                          name=""
                          id="tnp_agree"
                          checked={agree}
                          onChange={handleAgree}
                        />
                        <label htmlFor="tnp_agree"><span>탈퇴 전 유의사항 안내를 확인하였으며, 이에 동의합니다.</span></label>
                      </div>
                    </div>
                  </div>
                  <div className="acc_input_wrap">
                    <div className="text_wrap">
                      <p>개인 정보 보호를 위해 본인 인증을 진행합니다.</p>
                    </div>
                    <div className="email_wrap input_out">
                      <label htmlFor="uname" className="sr"><b>Email</b></label>
                      <div className="basic_input_box">
                        <div className="input_wrap">
                          <input
                            type="email"
                            placeholder="E-mail"
                            name="uname"
                            className="email"
                            required
                            onChange={onChangeEmail}
                            maxLength={50}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="pass_wrap input_out">
                      <label htmlFor="psw" className="sr"><b>Password</b></label>
                      <div className="basic_input_box">
                        <div className="input_wrap">
                          <input
                            type={pwShow ? "text" : "password"}
                            placeholder="Password"
                            name="psw"
                            id="password"
                            required
                            className="input_pass"
                            onChange={onChangePwd}
                            maxLength={50}
                          />
                          <i className={clsx("icon_32 pass_icon", pwShow && 'active bi_eye')} onClick={handlePwShow}>
                            <img src={`${process.env.PUBLIC_URL}/static/images/icon/pass_hide_32.svg`} className="pass_h_icon" alt=""/>
                            <img src={`${process.env.PUBLIC_URL}/static/images/icon/pass_view_32.svg`} className="pass_s_icon" alt=""/>
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </article>
          </div>
        </section>
        <article
          className={clsx(
            "bottom_zero_btn_wrap",
            (agree) && 'active'
          )}
        >
          <button
            className={clsx(
              "bottom_zero_btn bottom_btn_conform",
              (input && agree) && 'active'
            )}
            onClick={onSubmit}
          >
            <span>회원탈퇴</span>
          </button>
        </article>
      </main>
    </div>
  );
}

export default GoogleLeavePage;